import { STAGES } from './stages';
import { cx } from './util';

// §2.1 ladder glyph: eight ticks filled to the stage's position, so the ordinal reads without colour.
export function LadderGlyph({ rung }) {
  return (
    <svg className="ui-stage__glyph" width="31" height="8" viewBox="0 0 31 8" aria-hidden="true">
      {STAGES.map((_, i) => <rect key={i} x={i * 4} y="0" width="3" height="8" rx="1" fill="currentColor" opacity={i < rung ? 1 : 0.28} />)}
    </svg>
  );
}

// §2.6 Stage chip. stage: one of the eight rungs. number shows the rung (Production stage rail only);
// current adds the accent outline; todo renders a rung that has not been reached (rail only).
export default function StageChip({ stage, number = false, current = false, todo = false, className }) {
  const rung = STAGES.indexOf(stage) + 1;
  if (!rung) return null;
  return (
    <span className={cx('ui ui-stage', `ui-stage--${rung}`, current && 'ui-stage--current', todo && 'ui-stage--todo', className)}
      aria-label={`Stage ${rung} of 8: ${stage}`} aria-current={current ? 'step' : undefined}>
      <LadderGlyph rung={rung} />
      {number && <span className="ui-stage__num" aria-hidden="true">{rung}</span>}
      <span aria-hidden="true">{stage}</span>
    </span>
  );
}
